export const getDefault = () => {
  const schema = {
    name: 'SubWebEvents',
    title: 'Programa',
    description: 'ver programa completo',
    buttonLink: 'https://www.ua.pt/agenda',
    hasButton: true,
    href: 'https://www.ua.pt/agenda',
    hasLink: true,
    hasLine: true,
    hasImageSection: true,
    imageCover: 'https://static.ua.pt/images/ua/placeholder-bw.png',
    data: [
      {
        type: 'right',
        cards: [
          {
            title: 'Titulo',
            description: 'Descrição',
            href: 'https://greatevent.com',
            startDate: '2020-01-15T00:00:00',
            endDate: '2020-01-30T00:00:00',
            image: 'https://static.ua.pt/images/ua/placeholder-bw.png'
          },
          {
            title: 'Titulo',
            description: 'Descrição',
            href: 'https://greatevent.com',
            startDate: '2020-01-20T00:00:00',
            endDate: '2020-01-22T00:00:00',
            image: 'https://static.ua.pt/images/ua/placeholder-bw.png'
          }
        ]
      },
      {
        type: 'left',
        cards: [
          {
            title: 'Titulo',
            description: 'Descrição',
            href: 'https://greatevent.com',
            startDate: '2020-01-15T00:00:00',
            endDate: '2020-02-12T00:00:00',
            image: 'https://static.ua.pt/images/ua/placeholder-bw.png'
          },
          {
            title: 'Titulo',
            description: 'Descrição',
            href: 'https://greatevent.com',
            startDate: '2020-02-05T00:00:00',
            endDate: '2020-04-15T00:00:00',
            image: 'https://static.ua.pt/images/ua/placeholder-bw.png'
          }
        ]
      },
      {
        type: 'extend',
        cards: [
          {
            title: 'Titulo',
            description: 'Descrição',
            href: 'https://greatevent.com',
            hasEndDate: false,
            startDate: '2020-05-19T00:00:00',
            endDate: '2020-05-29T00:00:00',
            image: 'https://static.ua.pt/images/ua/placeholder-bw.png'
          }
        ]
      }
    ]
  }
  return schema
}
